"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _bullet = require("@nivo/bullet");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var _default = exports["default"] = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement(_bullet.ResponsiveBullet, _extends({
    data: [],
    rangeColors: "pastel2",
    margin: {
      top: 50,
      right: 90,
      bottom: 50,
      left: 90
    },
    spacing: 46,
    titleAlign: "start",
    titleOffsetX: -70,
    measureSize: 0.2,
    animate: true,
    motionStiffness: 90,
    motionDamping: 12
  }, props));
};